import Vue from 'vue'
import VueRouter from 'vue-router'
import { VLayout } from 'vuetify/lib'
import AirMap from '../views/AirMap.vue'
import ChartModal from '../views/ChartModal.vue'
import SmileMap from '../views/SmileMap.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: {
      render: h => h(VLayout, [h(AirMap), h(ChartModal)]),
    },
  },
  {
    path: '/smiley',
    name: 'smiley',
    component: SmileMap
  },
]

const router = new VueRouter({
  routes
})

export default router

